var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55556 15.5C5.55556 15.8978 5.71944 16.2794 6.01117 16.5607C6.30289 16.842 6.69855 17 7.11111 17H14.8889C15.3014 17 15.6971 16.842 15.9888 16.5607C16.2806 16.2794 16.4444 15.8978 16.4444 15.5V6.5H18V5H14.8889V3.5C14.8889 3.10218 14.725 2.72064 14.4333 2.43934C14.1416 2.15804 13.7459 2 13.3333 2H8.66667C8.25411 2 7.85845 2.15804 7.56672 2.43934C7.275 2.72064 7.11111 3.10218 7.11111 3.5V5H4V6.5H5.55556V15.5ZM8.66667 3.5H13.3333V5H8.66667V3.5ZM7.88889 6.5H14.8889V15.5H7.11111V6.5H7.88889Z",
    fill: "#DF6565"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e5f6ff26ac0b9e09ba4f966d1385c05e.svg";
export { ForwardRef as ReactComponent };